module.exports = __webpack_public_path__ + "img/uchi.efb47ca9.svg";